import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import {
  type InventoryReportSearch,
  inventoryReportSearchFrom,
} from '@/features/inventory-analysis/api'
import { SalesPerformanceReportScreen } from '@/features/inventory-analysis/performance-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/reports/performance')({
  validateSearch: (search: Record<string, unknown>): InventoryReportSearch =>
    inventoryReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'inventory_report.view'))
      throw redirect({ to: '/inventory' })
  },
  component: SalesPerformanceReportRoute,
})

function SalesPerformanceReportRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <SalesPerformanceReportScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/inventory/reports/performance', search: next })
      }
    />
  )
}
